"use strict";

exports.__esModule = true;
exports.ClassificationButtonGroup = void 0;
var _uiSwitch = require("../../Theme/UiDesign/uiSwitch");
var _ClassificationButtonGroup = require("./ClassificationButtonGroup.legacy");
var _ClassificationButtonGroup2 = require("./ClassificationButtonGroup.modern");
// Flag-gated UI: `ClassificationButtonGroup.legacy` is the component as it is on master,
// `ClassificationButtonGroup.modern` the ui-charts-update rewrite. The nearest UiDesignProvider
// (ENABLE_MODERN_UI + the screen's flag) decides which one renders.
var ClassificationButtonGroup = exports.ClassificationButtonGroup = (0, _uiSwitch.uiSwitch)(_ClassificationButtonGroup.ClassificationButtonGroup, _ClassificationButtonGroup2.ClassificationButtonGroup, "ClassificationButtonGroup");